<div id="instances-list">
  @for(instance of (appInstances | async); track instance) {
  <div class="instance-list-item" (click)="selectInstance(instance)">
    <span>{{instance.name}}</span>
  </div>
  }
</div>